import styled from '@emotion/styled';
import { Box, Spinner } from '@kc-console/common-ui';

import type { SpinnerProps } from '@kc-console/common-ui';

export type LayoutPartialLoaderProps = {
  /**
    로더 컨텐츠의 우선순위를 결정합니다.
    @default zIndex
   */
  contentZIndex?: number;
  open?: boolean;
  /**
    컴포넌트 요소의 우선순위를 결정합니다.
    @default 1
   */
  zIndex?: number;
} & SpinnerProps;

export const LayoutPartialLoader = ({
  open = false,
  zIndex = 1,
  contentZIndex = zIndex,
  ...props
}: LayoutPartialLoaderProps) => {
  return (
    open && (
      <Box>
        <StyledBackground zIndex={zIndex} />
        <StyledSpinner zIndex={contentZIndex} {...props} size="lg" />
      </Box>
    )
  );
};

const StyledBackground = styled(Box)<{ zIndex: LayoutPartialLoaderProps['zIndex'] }>`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: ${({ zIndex }) => zIndex};
`;

const StyledSpinner = styled(Spinner)<{ zIndex: LayoutPartialLoaderProps['zIndex'] }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${({ zIndex }) => zIndex};
`;
